/**
 * MSAL config for expert app Microsoft (Azure AD) login.
 * Follows: https://learn.microsoft.com/en-us/entra/msal/javascript/browser/initialization
 *
 * Set in .env: VITE_APP_MSAL_CLIENT_ID (optional; when set, Microsoft login is offered).
 * In Azure portal, register a SPA with redirect URI matching your app.
 */
import { type Configuration, LogLevel } from '@azure/msal-browser';

const clientId = import.meta.env.VITE_APP_MSAL_CLIENT_ID as string;

export const msalConfig: Configuration = {
  auth: {
    clientId,
    authority: 'https://login.microsoftonline.com/common',
    redirectUri: window.location.origin,
  },
  system: {
    loggerOptions: {
      logLevel: LogLevel.Error,
    },
  },
};

/** Scopes for sign-in; openid/profile/email ensure we get an id_token for the backend. */
export const loginRequest = {
  scopes: ['openid', 'profile', 'email'],
};
